var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeywordResearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    id: "Search-Visual--Streamline-Plump",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Search Visual Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-visual"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13 3s-3.086 0 -6.356 0.193a3.66 3.66 0 0 0 -3.45 3.45C3 9.913 3 13 3 13M35 3s3.086 0 6.356 0.193a3.66 3.66 0 0 1 3.45 3.45C45 9.913 45 13 45 13M35 45s3.086 0 6.356 -0.193a3.66 3.66 0 0 0 3.45 -3.45C45 38.087 45 35 45 35M13 45s-3.086 0 -6.356 -0.193a3.66 3.66 0 0 1 -3.45 -3.45C3 38.087 3 35 3 35",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M33.17 28.655A12.939 12.939 0 0 0 35 22c0 -7.18 -5.82 -13 -13 -13S9 14.82 9 22s5.82 13 13 13a12.94 12.94 0 0 0 6.737 -1.88l0.055 0.066c1.1 1.328 2.184 2.635 3.397 3.923 1.086 1.154 2.724 1.301 3.876 0.213a33.246 33.246 0 0 0 1.325 -1.325c1.088 -1.151 0.94 -2.79 -0.213 -3.876 -1.289 -1.213 -2.596 -2.296 -3.923 -3.396l-0.084 -0.07Z",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 17",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16 22a6 6 0 1 0 12 0 6 6 0 1 0 -12 0",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordResearchIcon);
export default __webpack_public_path__ + "static/media/keyword-research-icon.cd03c68c33630903400e536e1311e774.svg";
export { ForwardRef as ReactComponent };